import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';
import './Veo2FAQ.scss';

const Veo2FAQ = () => {
  const { t } = useI18n();
  const faqs = t('videoGeneration.veo.faq.items');
  return (
    <section className="veo2-faq">
      <div className="veo2-faq__inner">
        <h2 className="veo2-faq__title">{t('videoGeneration.veo.faq.title')}</h2>
        <p className="veo2-faq__subtitle">{t('videoGeneration.veo.faq.subtitle')}</p>
        <div className="veo2-faq__grid">
          {faqs.map((f) => (
            <article key={f.num} className="veo2-faq__item">
              <span className="veo2-faq__num">{f.num}</span>
              <div className="veo2-faq__content">
                <h3>{f.q}</h3>
                <p className="veo2-faq__a">{f.a}</p>
              </div>
            </article>
          ))}
        </div>
        {/* <div className="veo2-faq__footer">
          <a className="veo2-faq__link" href="#">
            {t('videoGeneration.veo.faq.more')}<span>{t('videoGeneration.veo.faq.contact')}</span>
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Veo2FAQ;